import SourceFlowImage from '@sourceflow-uk/sourceflowimage';
import { Container, Card, Stack } from "react-bootstrap";
import useConsultants from '@/hooks/useConsultants';
import Link from 'next/link';
import styles from './styles.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper';
import Arrow from '/public/site-assets/svg/black-arrow.svg';
import Mail from '/public/site-assets/svg/mail.svg';
import LinkedIn from '/public/site-assets/svg/linkedin.svg';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

export const TeamCarousel = ({
  className,
  title,
  heading,
  titleColour,
  content,
  buttonLink,
  buttonTitle,
  consultants
}) => {

  const items = useConsultants();

  const filteredItems = consultants?.length > 0 ? items.filter((member) => consultants?.includes(member?.id)) : items;

  if (!filteredItems || !filteredItems.length > 0) {
    return null;
  }

  const settings = {
    modules: [Navigation, Autoplay],
    loop: true,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
    },
    navigation: {
      nextEl: `.teamCarouselSwiper.swiper-next`,
      prevEl: `.teamCarouselSwiper.swiper-prev`,
    },
    spaceBetween: 20,
    autoHeight: true,
  };
  
  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        {title &&
          <h2
            className={`text-${titleColour?.variant} ${heading} mb-1`}
            style={titleColour?.custom ? { color: titleColour?.custom } : null}
          >
            {title}
          </h2>
        }
        {content &&
          <div dangerouslySetInnerHTML={{ __html: content }} />
        }
        {buttonLink && buttonTitle &&
          <Link href={buttonLink}>
            <a className="primaryBtn no-arrow m-0">
              {buttonTitle}
            </a>
          </Link>
        }
        <div className="position-relative mt-3">
          <Swiper {...settings}>
            {filteredItems?.map((item, index) => (
              <SwiperSlide key={index}>
                <Card className={`${styles.TeamMemberCard} p-3 p-md-4`}>
                  <Card.Img
                    as={SourceFlowImage}
                    className="rounded-4 w-auto"
                    src={item.image}
                    size="227x227"
                    alt=""
                  />
                  <Card.Body className="pb-0">
                    {item.title &&
                      <Card.Title as="h4">
                        <strong>{item.title}</strong>
                      </Card.Title>
                    }
                    {item.position &&
                      <Card.Subtitle as="i" className="d-block text-muted mb-3">{item.position}</Card.Subtitle>
                    }
                    {item.content &&
                      <Card.Text as="div" className="mb-2" dangerouslySetInnerHTML={{ __html: item.content }} />
                    }
                    {item.email && item.linkedin &&
                      <Stack className="flex-row justify-content-start align-items-center gap-3">
                        {item.email &&
                          <Link href={`mailto:${item.email}`}>
                            <a title="Mail">
                              <Mail />
                            </a>
                          </Link>
                        }
                        {item.linkedin &&
                          <Link href={item.linkedin}>
                            <a target="_blank" rel="noopener noreferrer" title="LinkedIn">
                              <LinkedIn />
                            </a>
                          </Link>
                        }
                      </Stack>
                    }
                  </Card.Body>
                </Card>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={`${styles.navigation}`}>
            <button className="teamCarouselSwiper swiper-prev border-0 p-0" aria-label="Prev">
              <Arrow />
            </button>
            <button className="teamCarouselSwiper arrow swiper-next border-0 ms-2 p-0" aria-label="Next">
              <Arrow />
            </button>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default TeamCarousel;
